import React, { useState, useEffect } from "react";
import { ArrowBackIosNewRounded, ArrowForwardIosRounded } from "@mui/icons-material";
import classes from './charts.module.css'



const TablePagination = ({ currentPage, totalPages, onPageChange, totalItems }) => {

    const [draftPage, setDraftPage] = useState(currentPage);
    useEffect(() => {
        setDraftPage(currentPage);
    }, [currentPage]);

    const commitPage = (page) => {

        const validPage = Math.max(1, Math.min(totalPages, page));
        onPageChange(validPage);
    };

    const handleInputChange = (e) => {

        const onlyDigits = e.target.value.replace(/\D/g, "");
        setDraftPage(onlyDigits);
    };

    const handleKeyDown = (e) => {
        if (e.key === "Enter") {
            const num = Number(draftPage);
            if (!isNaN(num)) commitPage(num);
        }
    };

    const handleBlur = () => {
        const num = Number(draftPage);
        if (!isNaN(num)) commitPage(num);
        else setDraftPage(currentPage);
    };

    return (
        <div className={classes.custompagination}>
            <span>
                Total count <strong>{totalItems}</strong>
            </span>
            <span className={classes.divider}>|</span>
            <span>
                Page{" "}
                <input
                    type="text"
                    min={1}
                    max={totalPages}
                    value={draftPage}
                    onChange={handleInputChange}
                    onKeyDown={handleKeyDown}
                    onBlur={handleBlur}
                    className="page-input"
                />{" "}
                of <strong>{totalPages}</strong>
            </span>
            <button
                onClick={() => commitPage(currentPage - 1)}
                disabled={currentPage === 1}
                className={classes.navbutton}
            >
                <ArrowBackIosNewRounded size={18} />
            </button>
            <button
                onClick={() => commitPage(currentPage + 1)}
                disabled={currentPage === totalPages}
                className={classes.navbutton}
            >
                <ArrowForwardIosRounded size={18} />
            </button>
        </div>
    );
};

export default TablePagination;
